"use strict";
exports.__esModule = true;
var apollo_link_1 = require("apollo-link");
exports.promiseToObservable = function (promise) {
    return new apollo_link_1.Observable(function (subscriber) {
        promise.then(function (value) {
            if (subscriber.closed) {
                return;
            }
            subscriber.next(value);
            subscriber.complete();
        }, function (err) {
            subscriber.error(err);
        });
    });
};
//# sourceMappingURL=promise-to-observable.js.map